/**
 * Coordinates session-expiry UX — single global signal, no duplicate modals.
 * Tokens are cleared in tokenRefresh before this fires; AuthContext shows UI then logout on confirm.
 */
import axios from 'axios';
import { eventBus } from '../../platform/eventBus';
import { AUTH_EVENTS } from './tokenRefresh';

let sessionExpiredActive = false;

const AUTH_SESSION_ERROR_MESSAGES = new Set([
  'No refresh token available',
  'RefreshToken endpoint did not return a token',
  'Session expired',
]);

/** True when a refresh/access failure indicates the user must re-authenticate. */
export const isAuthSessionFailure = (error: unknown): boolean => {
  if (error instanceof Error && AUTH_SESSION_ERROR_MESSAGES.has(error.message)) {
    return true;
  }

  const status = axios.isAxiosError(error)
    ? error.response?.status
    : (error as { response?: { status?: number } } | null)?.response?.status;

  // Only hard auth failures force logout — other 4xx (e.g. validation 400) are retryable.
  return status === 401 || status === 403;
};

/** Returns true when this call activated the session-expired flow (first caller only). */
export const signalSessionExpired = (): boolean => {
  if (sessionExpiredActive) {
    console.log('[SessionExpired] Already active, skipping duplicate signal');
    return false;
  }
  sessionExpiredActive = true;
  console.log('[SessionExpired] Signaling SESSION_EXPIRED event');
  eventBus.emit(AUTH_EVENTS.SESSION_EXPIRED);
  return true;
};

export const isSessionExpiredActive = (): boolean => sessionExpiredActive;

export const resetSessionExpiredCoordinator = (): void => {
  sessionExpiredActive = false;
};